import { Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
export class MetricModalContext {
  public configObj: any;
  onClose: any;
}

@Component({
  selector: 'app-metric-modal',
  templateUrl: './metric-modal.component.html',
  styleUrls: ['./metric-modal.component.scss']
})
export class MetricModalComponent {
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  public context!: MetricModalContext;
  public configObj: any = {};

  constructor(public dialog: BsModalRef<MetricModalContext>) {}

  public closeModalWindow() {
    this.dialog.hide();
  }
}
